export enum VisitAction {
    Alert = 1,
    Raise = 2,
}
